import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import classnames from 'classnames';

import { CurrencyProvider } from 'dibs-buyer-layout/exports/CurrencyProvider';
import { TilePrice as Price } from 'dibs-search-product-tile/exports/TilePrice';
import { LazyImageWrapper } from '../../components/global/LazyImageWrapper';
import { ItemImage } from '../../components/global/ItemImage';

import {
    VERTICAL_OFFSET_MOBILE_IMG,
    HORIZONTAL_OFFSET_MOBILE_IMG,
} from '../../constants/imageConstants';

import styles from './SbSharedCreatorSpotlightProductTile.scss';

function SbSharedCreatorSpotlightProductTileComponent({ className, edge, isClient }) {
    const { cmsData, node: item } = edge;

    return (
        <div className={classnames(styles.container, className)}>
            <div className={styles.imageLinkWrapper}>
                <a href={item.localizedPdpUrl} className={styles.imageLink}>
                    <div className={styles.imageWrapper}>
                        <LazyImageWrapper
                            offsetVertical={VERTICAL_OFFSET_MOBILE_IMG}
                            offsetHorizontal={HORIZONTAL_OFFSET_MOBILE_IMG}
                            item={item}
                        >
                            <ItemImage item={item} className={styles.image} isClient={isClient} />
                        </LazyImageWrapper>
                    </div>
                </a>
            </div>
            <div className={styles.info}>
                <a href={item.localizedPdpUrl} className={styles.title}>
                    {cmsData.title}
                </a>
                <div className={styles.price}>
                    <CurrencyProvider
                        render={({ currency }) => <Price currency={currency} item={item} />}
                    />
                </div>
            </div>
        </div>
    );
}

SbSharedCreatorSpotlightProductTileComponent.propTypes = {
    className: PropTypes.string,
    edge: PropTypes.object.isRequired,
    isClient: PropTypes.bool.isRequired,
};

export const SbSharedCreatorSpotlightProductTile = createFragmentContainer(
    SbSharedCreatorSpotlightProductTileComponent,
    {
        edge: graphql`
            fragment SbSharedCreatorSpotlightProductTile_edge on CmsItemsEdge {
                cmsData {
                    title
                }
                node {
                    localizedPdpUrl
                    ...LazyImageWrapper_item
                    ...ItemImage_item
                    ...Price_item @arguments(isTrade: $isTrade)
                }
            }
        `,
    }
);
